// Global
import React from 'react';

// Local
import { RecipeTradeMarks } from './RecipeTradeMarks';
import { ComponentProps } from 'lib/component-props';
import { RecipeResponse } from 'lib/services/models/content-response';
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';
import useDictionary from 'lib/hooks/useDictionary';

/**
 * Represents the template /sitecore/templates/Feature/GMI/Shared/Recipe/RecipeTradeMarks/RecipeTradeMarks
 */
export type RecipeTradeMarksSitecoreProps = ComponentProps;

export function RecipeTradeMarksWrapper() {
  const { sitecoreContext } = useSitecoreContext();
  const { getDictionaryValue } = useDictionary();
  const recipe = sitecoreContext.contentItem as RecipeResponse | undefined;
  const copyrightText = getDictionaryValue('Components.Recipe.RecipeCopyRightText').replace(
    '{currentYear}',
    new Date().getFullYear().toString()
  );

  return <RecipeTradeMarks recipe={recipe} copyrightText={copyrightText} />;
}

export const Default = RecipeTradeMarksWrapper;
